import angular from 'angular';
import './announcement.service.js';
import gridHeight from "../core/shared-service/grid-utils";

class AnnouncementListCtrl {
    /*@ngInject*/
    constructor($state, logger, AuthSvc, $uibModal, CommunitySvc, $scope, AnnouncementSvc) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.CommunitySvc = CommunitySvc;
        this.$scope = $scope;
        this.AnnouncementSvc = AnnouncementSvc;
        this.CommunitySvc = CommunitySvc;
    }

    $onInit() {
        this.getAllAnnouncements();
        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.announcement.update({ id : row.entity.id, forDuplication: false })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
         var duplicateCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.announcement.duplicate({ id : row.entity.id, forDuplication: true })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer"><i class="fa fa-files-o" aria-hidden="true"></i></div></a>';
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'category',
                    displayName: 'announcement.column.category',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                    cellFilter: 'translate',

                },
                {
                    name: 'title',
                    displayName: 'Titre',
                    headerCellFilter: 'translate',
                    cellClass: 'defaultcursor',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'startDate',
                    displayName: 'Date et heure de début de publication',
                    headerCellFilter: 'translate',
                    cellClass: 'defaultcursor',
                    cellFilter: "date:'dd/MM/yyyy'+' à '+ 'HH:mm'",
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'endDate',
                    displayName: 'Date et heure de fin de publication',
                    headerCellFilter: 'translate',
                    cellClass: 'defaultcursor',
                    cellFilter: "date:'dd/MM/yyyy'+' à '+ 'HH:mm'",
                    cellTemplate: defaultCellTemplate,
                }, {
                    name: 'duplication',
                    displayName: '',
                    cellFilter: "",
                    cellTemplate: duplicateCellTemplate,
                    width: 80,
                    cellClass: 'defaultcursor justify-content-center',

                },
            ],
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            onRowClicked: this.myRowClickedHandler,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
                    this.getAllAnnouncements((page - 1), size);
                });
            },
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
        };
    }


    getGridHeight() {
        return gridHeight(this.gridApi);
    }

    newAnnouncement() {
        this.$state.go('app.announcement.create');
    }

    isAuthorizedToCreate() {
        return this.AuthSvc.isAuthorized('SUPPORT');
    }


    getAllAnnouncements(page = 0, size = 20) {
        this.containerPromise = this.AnnouncementSvc.getAllAnnouncements(page, size);
        this.containerPromise.then(
            data => {
                if (data.totalElements != 0) {
                    this.gridOptions.data = data.content;
                    this.gridOptions.totalItems = data.totalElements
                }
            },
            () => {
                this.logger.error('error.search');
            }
        );
    }

}

angular.module('app.announcement').component('announcementList', {
    templateUrl: require('./announcement-list.html'),
    controller: AnnouncementListCtrl
});



